// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__gBiNH","logoBlock":"Advt_logoBlock__uZFQ2","title":"Advt_title__ZDIif","qrsWrapper":"Advt_qrsWrapper__yFFrw","qrCode":"Advt_qrCode__Vw6rK"};